<template>
    <div v-if="list.length > 0" :id="id" class="w-full px-30 mx-auto pt-50 lg:(j-w-1180 j-p-0 j-pt-80)">
      <h2 class="w-full text-40 leading-64 text-sub font-semibold px-50 text-left mb-30 lg:j-text-28 lg:j-leading-32 lg:text-black lg:text-center lg:j-mb-30">{{ title }}</h2>
      <div class="relative">
        <swiper
          :class="{
            'layout-center': list.length < 4 && !mobile,
            '!pb-50 !lg:j-pb-0 pc__swiper__item': true,
            [mobile ? `pc__swiper__item_${list[0][0].ruleId}`: '']: mobile && list.length > 0 && list[0] && list[0].length > 0
          }"
          :slides-per-view="slidesPerView"
          :slides-per-group="slidesViewGroup"
          :spaceBetween="spaceBetween"
          :navigation="false"
          :pagination="mobile"
          :modules="[Pagination]"
          :resizeObserver="true"
          @swiper="onSwiper"
          @resize="onSwiperResize"
          @slideChange="onSlideChange"
          ref="swiperContainer"
        >
        <!--        @resize="onSwiperResize" -->
          <swiper-slide v-for="item in list" :key="item">
            <SwiperCardItem
              :mobile="mobile"
              :item="item"
              :type="type"
              :length="pcList.length"
              :isLogin="props.isLogin"
              :isModal="false"
              :title="title"
            />
          </swiper-slide>
        </swiper>
        <template v-if="list.length > 4 && !mobile">
          <div class="swiper-button-prev swiper-button-disabled" slot="button-prev" @click="() => swiperInstance.slidePrev()">
            <left-outlined />
          </div>
          <div class="swiper-button-next" slot="button-next" @click="() => swiperInstance.slideNext()">
            <right-outlined />
          </div>
        </template>
      </div>
    </div>
</template>
<script setup>
// Import Swiper Vue.js components
import { Pagination, } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

import {
  getCouponsList, getCustomerCouponsList, getCustomerCouponsThingList, getCustomerGiftcardList,
  getCustomerVirtualCardsList, getGiftCardsList, getJackeryThingsList, getVirtualCardsList,
} from "@a/index";
import { LeftOutlined, RightOutlined, } from '@ant-design/icons-vue';
import { chunkArray, cookie, } from '@u/common';
import { shopLists } from "@a/userCommon";
import SwiperCardItem from './SwiperCardItem.vue';

import { breakpointsTailwind, useBreakpoints, } from '@vueuse/core'

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const props = defineProps({
  id: String,
  anchor: String,
  title: String,
  type: String,
  isLogin: Boolean
})

const SHOP_ID = cookie.get("_jk_shop_id") || localStorage.getItem('JACKERY_ID_SHOP_ID')
const swiperContainer = ref(null)
let pcList = ref([])
const minH = ref('')

const getShopId = async () => {
    const { current: { shop_id, }, } = await shopLists()
    return shop_id
}

onMounted(async () => {
  const METHOD_KEY = props.isLogin
    ? {
        'Coupon': getCustomerCouponsList,
        'Gift-Card':getCustomerGiftcardList,
        'Products': getCustomerCouponsThingList,
        'VirtualCard': getCustomerVirtualCardsList
      }
    : {
        'Coupon': getCouponsList,
        'Gift-Card': getGiftCardsList,
        'Products': getJackeryThingsList,
        'VirtualCard': getVirtualCardsList,
      }

  if (!SHOP_ID) {
    getShopId().then(async shop_id => {
      const { rights = [], } = await METHOD_KEY[props.type]({ shopId: shop_id, })
      pcList.value = rights || []
      onSwiperResize()
    })
    return
  }

  const { rights = [], } = await METHOD_KEY[props.type]({ shopId: SHOP_ID, })
  pcList.value = rights || []
  onSwiperResize()
})

const breakpoints = useBreakpoints(breakpointsTailwind)
const mobile = breakpoints.smaller('lg')

const spaceBetween = ref(20)
const slidesViewGroup = ref(4)
const slidesPerView = ref(4)

let list = ref([])
const swiperInstance = ref(null)
// 获取 swiper 实例
const onSwiper = (swiper) => {
    swiperInstance.value = swiper

    onSwiperResize()
}
const onSwiperResize = () => {
    const clientWidth = document.body.clientWidth
    spaceBetween.value = mobile.value ? clientWidth * 20 / 750 : (clientWidth + 8) * 20 / 1920

    // 一维数组 转 二维数组，每2个一组[布局变更 - mb：4/组]
    list.value = mobile.value ? chunkArray(pcList.value, 4) : pcList.value

    setTimeout(() => {
      // slidesViewGroup.value = mobile.value ? (pcList.value.length > 2 ? 2 : 1) : 4
      slidesViewGroup.value = mobile.value ? 1 : 4
      slidesPerView.value = mobile.value ? 'auto' : 4
    }, 500)

    setTimeout(() => {
      if(mobile.value && list.value.length > 0) {
      const wrapper = document.querySelector(`.pc__swiper__item_${list.value[0][0].ruleId}`)
      if(wrapper) {
        const _h = wrapper.querySelector('.swiper-wrapper').offsetHeight + 'px'
        wrapper.style.setProperty('--min-h', _h);
        wrapper.querySelectorAll('.swiper-slide').forEach(item => {
          item.style.minHeight = _h
          minH.value = _h
        })
      }
    }
    }, 20);
}

// 更新 按钮状态
const onSlideChange = (swiper) => {
    if (mobile.value) return false

    const prevBtn = swiper.el.parentElement.querySelector('.swiper-button-prev')
    const nextBtn = swiper.el.parentElement.querySelector('.swiper-button-next')
    if (swiper.isBeginning) {
        prevBtn.classList.add('swiper-button-disabled')
        nextBtn.classList.remove('swiper-button-disabled')
    }
    else if (swiper.isEnd) {
        nextBtn.classList.add('swiper-button-disabled')
        prevBtn.classList.remove('swiper-button-disabled')
    }
    else {
        nextBtn.classList.remove('swiper-button-disabled')
        prevBtn.classList.remove('swiper-button-disabled')
    }
}


const renderClass = () => {
  let mb_class = ''
  if(mobile && list.length < 4) {
    mb_class += 'line_low_swiper'
  }

  if(list.length > 0) {
    // mb_class += list[0].rule
  }

  return list.length < 4 && !mobile ? 'layout-center' : mb_class
}
</script>
<style scoped>
:deep(.layout-center .swiper-wrapper) {
  @apply !flex-center
}
:deep(.swiper-button-prev::after),
:deep(.swiper-button-next::after) {
  @apply hidden
}
:deep(.swiper-button-prev),
:deep(.swiper-button-next) {
  @apply
    lg:j-w-60 lg:j-h-60 bg-white rounded-full text-#9A9A9A text-8 hover:text-primary z-1;
}
:deep(.swiper-button-prev) {
  @apply -lg:j-left-120
}
:deep(.swiper-button-next) {
  @apply -lg:j-right-120
}
:deep(.swiper-button-disabled) {
  @apply opacity-60
}
:deep(.swiper-pagination-bullet) {
  @apply w-30 h-[3px] rounded-0 !mx-[3px] transition-all duration-500
}
:deep(.swiper-pagination-bullet-active) {
  @apply w-50 bg-primary
}
:deep(.swiper-pagination) {
  @apply bottom-0
}


@media screen and (max-width: 1024px) {
  :deep(.line_low_swiper .swiper-wrapper .swiper-slide) {
    /* min-height: 160px!important; */
  }
  .pc__swiper__item {
    --min-h: 'auto';
  }
  :deep(.swiper-wrapper .swiper-slide) {
    /* min-height: 320px!important; */
    min-height: var(--min-h)!important;;
  }
}
@media screen and (min-width: 1023px) {
  :deep(.layout-center .swiper-wrapper) {
    @apply !items-start
  }
  .w-full .pc__swiper__item .swiper-wrapper {
    justify-content: flex-start!important;
  }
}
</style>
